export class CurrencyModel {
  currencyId: number = 0;
  code: string = "";
  name: string = "";
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}